import React, { useState, useEffect, useRef } from 'react';
import EmployeeForm from '../hrm/employees/EmployeeForm.js';
import Pagination from '../../utils/pagination/Pagination.js';
import { Trash2, SquarePen, Eye, Plus, Send, CircleUserRound, ListRestart } from 'lucide-react';
import {
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  TableContainer,
  Checkbox,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  Button,
  ModalCloseButton,
  Spinner,
  IconButton
} from '@chakra-ui/react';
import { Link } from 'react-router-dom';
import ProgressBar from '../../utils/progressBar/ProgressBar.js';
import { getEmployees } from '../../redux/reduxApi/employeeReduxApi.js';
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { Search } from 'lucide-react';
import { deleteEmployee, countEmployees } from '../../redux/api/employeeApi/EmployeeApi.js';
import { deleteEmployeeAction, setFilteredStatus } from '../../redux/reduxSlice/EmployeeSlice.js';
import DealEmployeeForm from '../crm/deal/DealEmployeeForm.js';
import RoleSearchDrawer from './RoleSearchDrawer.js';
import { addInvitation } from '../../redux/api/userInvitation/userInvitationApi.js'
import MobileNav from '../../defaultLayout/MobileNav.js';

function RoleList() {
  const dispatch = useDispatch();
  const [showProgressBar, setShowProgressBar] = useState(false);
  const [deleteEmployeeROWID, setDeleteEmployeeROWID] = useState("");
  const [employeeROWID, setEmployeeROWID] = useState("");
  const [selectedRows, setSelectedRows] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(5);
  const [isOpen, setIsOpen] = useState(false);
  const getEmployeeData = useSelector((state) => state?.employee?.employee);
  const [employeeData, setEmployeeData] = useState([]);
  const [data, setData] = useState([]);
  const [dataToEdit, setDataToEdit] = useState({});
  console.log("dataToEdit",dataToEdit);
  
  const [isUpdateMode, setIsUpdateMode] = useState(false);
  const [totalCount, setTotalCount] = useState(0);
  const getRoleData = useSelector((state) => state.utils.roleList);
  const [role, setRole] = useState([]);
  const [openSearch, setOpenSearch] = useState(false);
  const desktopRef = useRef(null);
  const mobileRef = useRef(null);
  const [showMobileNav, setShowMobileNav] = useState(true);
  const [lastScrollY, setLastScrollY] = useState(0);
  const scrollRef = useRef(null);
  const [ismobile, setIsmobile] = useState(false);
  const [isDealFormOpen, setIsDealFormOpen] = useState(false);
  const [itemsPerPage, setItemsPerPage] = useState(30);
  const isFiltered = useSelector((state) => state.employee.isFiltered);

  useEffect(() => {
    setEmployeeData(getEmployeeData);
  }, [getEmployeeData]);

  useEffect(() => {
    setRole(getRoleData)
  }, [getRoleData])

  useEffect(() => {
    if (employeeData && employeeData.length > 0) {
      setData(employeeData);
    }
  }, [employeeData]);

  // Handle resize
  const handleResize = () => {
    if (window.innerWidth < 600) {
      desktopRef.current.classList.add("d-none");
      mobileRef.current.classList.remove("d-none");
      setIsmobile(true);
    } else {
      desktopRef.current.classList.remove("d-none");
      mobileRef.current.classList.add("d-none");
      setIsmobile(false);
    }
  };

  useEffect(() => {
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const roleName = (roleName) => {
    const roleData = role.filter((item) => item.roles?.ROWID === roleName);
    return roleData[0]?.roles.roleName || "N/A";
  };

  // Handle Delete Function
  const handleDelete = () => {
    setShowProgressBar(true);
    setLoading(true);
    const idsToDelete = selectedRows.length === 0 ? [deleteEmployeeROWID] : selectedRows;
    
    Promise.all(idsToDelete.map((id) => deleteEmployee(id)))
      .then(() => {
        setData((prevData) =>
          prevData.filter((item) => !idsToDelete.includes(item.employees.ROWID))
        );
        dispatch(deleteEmployeeAction(idsToDelete));
        fetchTotalCount(); // Update count after deletion
        toast.success("Row Deleted successfully");
      })
      .catch((error) => {
        console.log(error);
        toast.error("Row not deleted");
      })
      .finally(() => {
        setShowProgressBar(false);
        setLoading(false);
        closeTrash();
        setSelectedRows([]);
        setEmployeeROWID("");
      });
  };

  const openDrawer = () => setIsDrawerOpen(true);
  const closeDrawer = () => setIsDrawerOpen(false);
  const [isDrawerOpen1, setIsDrawerOpen1] = useState(false);
  const openDrawer1 = () => setIsDrawerOpen1(true);
  const closeDrawer1 = () => setIsDrawerOpen1(false);
  const openTrash = () => setIsOpen(true);
  const closeTrash = () => setIsOpen(false);
  const openSearchDrawer = () => setOpenSearch(true);
  const closeSearchDrawer = () => setOpenSearch(false);
  const [filteredCount, setFilteredCount] = useState(0); // NEW: Track filtered count

  // Single Select
  const handleRowSelect = (ROWID) => {
    const isSelected = selectedRows.includes(ROWID);
    let newSelectedRows = [];

    if (!isSelected) {
      newSelectedRows = [...selectedRows, ROWID];
    } else {
      newSelectedRows = selectedRows.filter((rowEmployeeId) => rowEmployeeId !== ROWID);
    }
    setSelectedRows(newSelectedRows);
    setEmployeeROWID(newSelectedRows.join(","));
  };

  // All Select
  const handleSelectAllRows = () => {
    const allSelected = selectedRows.length === data.length;
    let newSelectedRows = [];
    if (!allSelected) {
      newSelectedRows = data.map((item) => item.employees?.ROWID);
    }
    setSelectedRows(newSelectedRows);
  };

  // Handle update
  const handleUpdate = (id) => {
    setEmployeeROWID(id);
    setIsUpdateMode(!isUpdateMode);
  };

  // Fetch total count - with filter support
  const fetchTotalCount = async (searchQuery = null) => {
    try {
      // If filtered, pass the search query to get filtered count
      const response = searchQuery 
        ? await countEmployees(searchQuery) 
        : await countEmployees();
      
      const count = parseInt(response.data.count, 10);
      setTotalCount(count);
      
      // Calculate total pages based on count
      setTotalPages(Math.ceil(count / itemsPerPage));
    } catch (error) {
      console.error("Error fetching total Employee count:", error);
    }
  };

  const handleInvitation = (email) => {
    console.log("hyy", email);
    const payload = { email: [email] }

    addInvitation(payload)
      .then(() => toast.success("Invitation Sent SuccesFully !!"))
      .catch((error) => toast.error("Some Error Occurred from sending Invitation"))
  }

  // Scroll handling
  const handleScroll = () => {
    if (scrollRef.current) {
      const currentScrollY = scrollRef.current.scrollTop;
      console.log("Current scrollY in content: ", currentScrollY);
      if (currentScrollY > lastScrollY) {
        setShowMobileNav(false);
      } else {
        setShowMobileNav(true);
      }
      setLastScrollY(currentScrollY);
    }
  };

  useEffect(() => {
    const contentElement = scrollRef.current;
    if (contentElement) {
      contentElement.addEventListener('scroll', handleScroll);
    }
    return () => {
      if (contentElement) {
        contentElement.removeEventListener('scroll', handleScroll);
      }
    };
  }, [lastScrollY]);

  // Main data fetching effect with pagination
  useEffect(() => {
    setLoading(true);
    
    const savedEmployeesSearchQuery = sessionStorage.getItem("employeeSearchQuery");
    
    if (savedEmployeesSearchQuery && isFiltered) {
      const queryPayload = {
        ...JSON.parse(savedEmployeesSearchQuery),
        page: currentPage,
        size: itemsPerPage
      };
      
      dispatch(getEmployees(queryPayload))
        .then((response) => {
          console.log("responseData",response?.payload?.data);
          
          const responseData = response.payload?.data || [];
          console.log("responseData--->",responseData.length);
          
          const totalCountFromAPI = response.payload?.data?.totalCount;
          
          setData(responseData);
          setFilteredCount(responseData.length);
          dispatch(setFilteredStatus(true));
          
          // Update count and pages from filtered results
          if (totalCountFromAPI !== undefined) {
            setTotalCount(totalCountFromAPI);
            setTotalPages(Math.ceil(totalCountFromAPI / itemsPerPage));
          } else {
            // Fallback: fetch count separately
            fetchTotalCount(queryPayload);
          }
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          setLoading(false);
        });
    } else {
      dispatch(getEmployees({ 
        page: currentPage, 
        size: itemsPerPage 
      }))
        .then((response) => {
          const responseData = response.payload?.data?.response || [];
          const totalCountFromAPI = response.payload?.data?.totalCount;
          
          setData(responseData);
          
          // Update count and pages
          if (totalCountFromAPI !== undefined) {
            setTotalCount(totalCountFromAPI);
            setTotalPages(Math.ceil(totalCountFromAPI / itemsPerPage));
          } else {
            fetchTotalCount();
          }
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          setLoading(false);
        });
    }
  }, [currentPage, itemsPerPage, dispatch, isFiltered]);

  const handleReset = () => {
    setLoading(true);
    dispatch(setFilteredStatus(false));
    sessionStorage.removeItem("employeeSearchQuery");
    setCurrentPage(1); // Reset to first page

    dispatch(getEmployees({
      page: 1, 
      size: itemsPerPage 
    }))
      .then((response) => {
        const responseData = response.payload?.data?.response || [];
        const totalCountFromAPI = response.payload?.data?.totalCount;
        
        setData(responseData);
         setFilteredCount(0); // NEW: Reset filtered count when not filtered
        
        if (totalCountFromAPI !== undefined) {
          setTotalCount(totalCountFromAPI);
          setTotalPages(Math.ceil(totalCountFromAPI / itemsPerPage));
        } else {
          fetchTotalCount();
        }
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
      });
  };

  const toggleFilter = () => {
    if (isFiltered) {
      handleReset();
    } else {
      openSearchDrawer();
    }
  };

    // NEW: Get display count based on filter status
  const getDisplayCount = () => {
    return isFiltered ? filteredCount : totalCount;
  };

  return (
    <>
      {loading && (
        <div className="spinner-overlay">
          <Spinner size="xl" color="pink.500" />
        </div>
      )}
      {showProgressBar && <ProgressBar colorScheme="pink" />}
      
      {/* Trash modal confirmation */}
      <Modal isOpen={isOpen} onClose={closeTrash}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Are you sure you want to Delete?</ModalHeader>
          <ModalCloseButton />
          <ModalBody></ModalBody>
          <ModalFooter>
            <Button className='create-button' mr={3} onClick={handleDelete}>
              Delete
            </Button>
            <Button className='cancel-button' onClick={closeTrash}>Cancel</Button>
          </ModalFooter>
        </ModalContent>
      </Modal>

      <div>
        {selectedRows.length > 0 && (
          <div style={{display:"flex", margin:"5px 10px"}}>
            <div className="align-items-left d-flex gap-2">
              <Button className="inviteButton">
                Send Invititation <Send className='mx-1' size="20px" strokeWidth="2" />
              </Button>
            </div>
            <button className="new-button mx-2" onClick={openTrash}>
              <Plus size="18px" />
              <span className="ms-1">Delete All</span>
            </button>
          </div>
        )}

        {selectedRows.length === 0 && (
          <div className="d-flex justify-content-end">
            <span>
              <IconButton
                icon={isFiltered ? <ListRestart /> : <Search className="search-icon" color="#ff176b" size="28px" strokeWidth="2" style={{ cursor: "pointer", marginRight: "15px" }} />}
                onClick={toggleFilter}
              />
            </span>
            <button className="new-button mx-2 mb-1" onClick={openDrawer}>
              <Plus size="18px" />
              <span className="ms-1">New</span>
            </button>
          </div>
        )}

        {/* Employee data table */}
        <div className='custom-scroll' style={{ height: "70vh" }}>
          <TableContainer className='card card-detail'>
            <Table variant='simple' size='sm'>
              <Thead>
                <Tr className='tr-border'>
                  <Th className="py-1 th-color">
                    <Checkbox
                      isChecked={selectedRows?.length === data?.length}
                      onChange={handleSelectAllRows} />
                  </Th>
                  <Th className='py-1 th-color'>Actions</Th>
                  <Th className='py-1 th-color'>Invite</Th>
                  <Th className='py-1 th-color'>Employee Name</Th>
                  <Th className='py-1 th-color'>Permission</Th>
                  <Th className='py-1 th-color'>Email</Th>
                  <Th className='py-1 th-color'>Employee Status</Th>
                  <Th className='py-1 th-color'>Created Time</Th>
                  <Th className='py-1 th-color'>Modified Time</Th>
                  <Th className='py-1 th-color'>Created By</Th>
                </Tr>
              </Thead>
              <Tbody>
                {/* FIXED: Directly map data instead of slicing employeeData */}
                {data.map((item, index) => (
                  <Tr key={index} className='tr-border'>
                    <Td>
                      <Checkbox
                        isChecked={selectedRows.includes(item?.employees?.ROWID)}
                        onChange={() => handleRowSelect(item?.employees?.ROWID)}
                      />
                    </Td>
                    <Td>
                      <div className="d-flex gap-1">
                        <Link to="/employee-detail-view" state={{ ROWID: item?.employees?.ROWID }}>
                          <i style={{ cursor: 'pointer' }}>
                            <Eye color="#ff176b" size="16px" strokeWidth="1" />
                          </i>
                        </Link>
                        <i onClick={() => {
                          openDrawer(item.employees); 
                          console.log("item.employees",item.employees);
                          
                          setDataToEdit(item.employees); 
                          setIsUpdateMode(true);
                        }} style={{ cursor: 'pointer' }}>
                          <SquarePen color="#ff176b" size="16px" strokeWidth="1" />
                        </i>
                        <i style={{ cursor: 'pointer' }} onClick={(e) => {
                          openTrash(e);
                          setDeleteEmployeeROWID(item?.employees?.ROWID);
                        }}>
                          <Trash2 color="#ff176b" size="16px" strokeWidth="1" />
                        </i>
                      </div>
                    </Td>
                    <Td>
                      <Button 
                        style={{ background: '#8ef6956b', color: 'green' }} 
                        onClick={() => handleInvitation(item?.employees?.email)}>
                        Send Invite <Send className='mx-1' size="20px" strokeWidth="2" />
                      </Button>
                    </Td>
                    <Td className='font-colors'>{item?.employees?.employeeName}</Td>
                    <Td className='font-colors d-inline-block my-1 d-flex' style={{ border: 'none' }}>
                      <Button className='text-truncate d-inline-block' 
                        style={{ color: '#f15872', background: '#fceaf0', width: '150px' }}>
                        {roleName(item?.employees?.permissions)}
                      </Button>
                    </Td>
                    <Td className='font-colors'>{item?.employees?.email}</Td>
                    <Td className='font-colors'>{item?.employees?.employeeStatus}</Td>
                    <Td className='font-colors'>{item?.employees?.CREATEDTIME?.slice(0, 16)}</Td>
                    <Td className='font-colors'>{item?.employees?.MODIFIEDTIME?.slice(0, 16)}</Td>
                    <Td className='font-colors'>info@trigya.co</Td>
                  </Tr>
                ))}
              </Tbody>
            </Table>
          </TableContainer>
        </div>

        <div className="footer d-flex fixed-bottom start-20" ref={desktopRef}>
          <div className="total" style={{ marginLeft: "20%", marginTop: "15px" }}>
            {/* <p className="fw-semibold">Total Count: {totalCount}</p> */}
             <p className="fw-semibold">
              {isFiltered ? `Filtered Count: ${filteredCount}` : `Total Count: ${totalCount}`}
            </p>
          </div>
          
          {/* Pagination */}
          <div className="d-flex align-items-center justify-content-center position-fixed-bottom mx-auto">
            <Pagination 
              totalPages={totalPages} 
              currentPage={currentPage}
              onPageChange={setCurrentPage} 
            />
          </div>

          <RoleSearchDrawer isOpen={openSearch} isClose={closeSearchDrawer} />
          
          {/* EmployeeForm Drawer */}
          <EmployeeForm 
            closeDrawer={() => setIsDrawerOpen(false)} 
            isDrawerOpen={isDrawerOpen} 
            isUpdateMode={isUpdateMode} 
            employeeROWID={employeeROWID} 
            setIsUpdateMode={setIsUpdateMode} 
            dataToEdit={dataToEdit}
          />
          
          {/* DealEmployeeForm Drawer */}
          {isDealFormOpen && (
            <DealEmployeeForm 
              employeeROWID={employeeROWID} 
              setIsUpdateMode={setIsUpdateMode} 
              dataToEdit={dataToEdit} 
            />
          )}
        </div>
      </div>

      {showMobileNav && (
        <div ref={mobileRef}>
          <MobileNav />
        </div>
      )}
    </>
  );
}

export default RoleList;